
export const paramateStyles = /*css*/`
.paramate-waitAnim
{
  position: relative;
  left: 50%;
  top: 50%;
  width: 40px;
}

.paramate-waitAnimContainer
{
  position: relative;
  left: -20px;
  top: -20px;
  width: 40px;
  height: 40px;
}

.paramate-waitAnimContainer .paramate-waitAnim-circle {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.paramate-waitAnimContainer .paramate-waitAnim-circle:before {
  content: '';
  display: block;
  margin: 0 auto;
  width: 15%;
  height: 15%;
  background-color: #333;
  border-radius: 100%;
  -webkit-animation: paramate-waitAnim-circleFadeDelay 1.2s infinite ease-in-out both;
          animation: paramate-waitAnim-circleFadeDelay 1.2s infinite ease-in-out both;
}
.paramate-waitAnimContainer .paramate-waitAnim-circle2 {
  -webkit-transform: rotate(30deg);
      -ms-transform: rotate(30deg);
          transform: rotate(30deg);
}
.paramate-waitAnimContainer .paramate-waitAnim-circle3 {
  -webkit-transform: rotate(60deg);
      -ms-transform: rotate(60deg);
          transform: rotate(60deg);
}
.paramate-waitAnimContainer .paramate-waitAnim-circle4 {
  -webkit-transform: rotate(90deg);
      -ms-transform: rotate(90deg);
          transform: rotate(90deg);
}
.paramate-waitAnimContainer .paramate-waitAnim-circle5 {
  -webkit-transform: rotate(120deg);
      -ms-transform: rotate(120deg);
          transform: rotate(120deg);
}
.paramate-waitAnimContainer .paramate-waitAnim-circle6 {
  -webkit-transform: rotate(150deg);
      -ms-transform: rotate(150deg);
          transform: rotate(150deg);
}
.paramate-waitAnimContainer .paramate-waitAnim-circle7 {
  -webkit-transform: rotate(180deg);
      -ms-transform: rotate(180deg);
          transform: rotate(180deg);
}
.paramate-waitAnimContainer .paramate-waitAnim-circle8 {
  -webkit-transform: rotate(210deg);
      -ms-transform: rotate(210deg);
          transform: rotate(210deg);
}
.paramate-waitAnimContainer .paramate-waitAnim-circle9 {
  -webkit-transform: rotate(240deg);
      -ms-transform: rotate(240deg);
          transform: rotate(240deg);
}
.paramate-waitAnimContainer .paramate-waitAnim-circle10 {
  -webkit-transform: rotate(270deg);
      -ms-transform: rotate(270deg);
          transform: rotate(270deg);
}
.paramate-waitAnimContainer .paramate-waitAnim-circle11 {
  -webkit-transform: rotate(300deg);
      -ms-transform: rotate(300deg);
          transform: rotate(300deg); 
}
.paramate-waitAnimContainer .paramate-waitAnim-circle12 {
  -webkit-transform: rotate(330deg);
      -ms-transform: rotate(330deg);
          transform: rotate(330deg); 
}
.paramate-waitAnimContainer .paramate-waitAnim-circle2:before {
  -webkit-animation-delay: -1.1s;
          animation-delay: -1.1s; 
}
.paramate-waitAnimContainer .paramate-waitAnim-circle3:before {
  -webkit-animation-delay: -1s;
          animation-delay: -1s; 
}
.paramate-waitAnimContainer .paramate-waitAnim-circle4:before {
  -webkit-animation-delay: -0.9s;
          animation-delay: -0.9s; 
}
.paramate-waitAnimContainer .paramate-waitAnim-circle5:before {
  -webkit-animation-delay: -0.8s;
          animation-delay: -0.8s; 
}
.paramate-waitAnimContainer .paramate-waitAnim-circle6:before {
  -webkit-animation-delay: -0.7s;
          animation-delay: -0.7s; 
}
.paramate-waitAnimContainer .paramate-waitAnim-circle7:before {
  -webkit-animation-delay: -0.6s;
          animation-delay: -0.6s; 
}
.paramate-waitAnimContainer .paramate-waitAnim-circle8:before {
  -webkit-animation-delay: -0.5s;
          animation-delay: -0.5s; 
}
.paramate-waitAnimContainer .paramate-waitAnim-circle9:before {
  -webkit-animation-delay: -0.4s;
          animation-delay: -0.4s;
}
.paramate-waitAnimContainer .paramate-waitAnim-circle10:before {
  -webkit-animation-delay: -0.3s;
          animation-delay: -0.3s;
}
.paramate-waitAnimContainer .paramate-waitAnim-circle11:before {
  -webkit-animation-delay: -0.2s;
          animation-delay: -0.2s;
}
.paramate-waitAnimContainer .paramate-waitAnim-circle12:before {
  -webkit-animation-delay: -0.1s;
          animation-delay: -0.1s;
}

@-webkit-keyframes paramate-waitAnim-circleFadeDelay {
  0%, 39%, 100% { opacity: 0; }
  40% { opacity: 1; }
}

@keyframes paramate-waitAnim-circleFadeDelay {
  0%, 39%, 100% { opacity: 0; }
  40% { opacity: 1; } 
}
  `